// Video data structure
// Add your video information here
export const videos = [
  {
    id: 1,
    title: "Live Performance",
    url: "https://youtu.be/Sw79xhgWDMo?si=CBmtdUad0OkrAwXJ" // Replace with actual video URL
  }
  // Add more videos here
];

